import { NgModule } from '@angular/core';

import { DealersTermsAndConditionsComponent } from './dealers.terms-and-conditions.component';
import { DealersService }                     from './dealers.service';
import { SharedModule }                       from '../shared/shared.module';

@NgModule({
  declarations: [
    DealersTermsAndConditionsComponent
  ],
  entryComponents: [
    DealersTermsAndConditionsComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    DealersService
  ]
})
export class DealersModule {}
